import React, { useState, useEffect, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { Offcanvas } from "bootstrap";
import "@fortawesome/fontawesome-free/css/all.min.css";

const Navbar = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const [categories, setCategories] = useState([]);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 990);

  const navigate = useNavigate();
  const offcanvasRef = useRef(null);
  const offcanvasInstance = useRef(null);

  /* ================== RESPONSIVE ================== */
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 990);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  /* ================== CATEGORÍAS ================== */
  useEffect(() => {
    axios
      .get(
        "https://ryc-soluciones-nicaragua.com/api/index.php?getAllCategory=true"
      )
      .then((res) =>
        setCategories(res.data.map((c) => ({ id: c.id, nombre: c.category })))
      );
  }, []);

  /* ================== OFFCANVAS ================== */
  useEffect(() => {
    if (offcanvasRef.current) {
      offcanvasInstance.current = new Offcanvas(offcanvasRef.current);
    }
  }, []);

  /* ================== SEARCH ================== */
  const handleSearchSubmit = (e) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      navigate(`/productos?search=${encodeURIComponent(searchQuery)}`);
    }
  };

  /* ================== CATEGORY CLICK ================== */
  const handleCategoryClick = (path) => {
    navigate(path);
    offcanvasInstance.current?.hide();
  };

  /* ================== BOTONES ================== */
  const botones = [
    {
      type: "link",
      to: "/productos/Liquidacion",
      className: "btn btn-danger btn-sm",
      icon: "fa-fire",
      text: "Liquidación",
    },
    {
      type: "link",
      to: "/productos/Novedades",
      className: "btn btn-warning btn-sm",
      icon: "fa-star",
      text: "Novedades",
    },
    {
      type: "button",
      className: "btn btn-primary btn-sm",
      icon: "fa-location-dot",
      text: "Contáctanos",
    },
  ];

  return (
    <nav
      className="navbar navbar-dark flex-column p-0"
      style={{ position: "sticky", top: 0, zIndex: 1050 }}
    >
      {/* ===== FILA 1 ===== */}
      <div className="w-100" style={{ backgroundColor: "#00377b" }}>
        <div className="container py-2 d-flex align-items-center gap-3">
          <Link to="/" className="rounded-circle border border-2 border-white p-1">
            <img
              src="https://ryc-soluciones-nicaragua.com/imagenes/cropped-cropped-logo-editable-192x192.png"
              alt="RyC"
              style={{ width: 55, height: 55 }}
            />
          </Link>

          {/* ===== BUSCADOR ===== */}
          <form
            onSubmit={handleSearchSubmit}
            style={{
              flexGrow: isMobile ? 1 : 0,
              width: isMobile ? "100%" : "45%",
              marginLeft: isMobile ? 0 : "10%",
            }}
          >
            <div className="input-group">
              <input
                type="search"
                className="form-control"
                placeholder="¿Qué estás buscando?"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                style={{
                  borderRadius: "35px 0 0 35px",
                  borderRight: "none",
                }}
              />
              <button
                className="btn"
                type="submit"
                style={{
                  background: "#fff",
                  border: "1px solid #ced4da",
                  borderLeft: "none",
                  borderRadius: "0 35px 35px 0",
                }}
              >
                <i className="fa-solid fa-magnifying-glass text-secondary"></i>
              </button>
            </div>
          </form>
        </div>
      </div>

      {/* ===== FILA 2 ===== */}
      <div
        className="w-100"
        style={{ backgroundColor: "#002b5c", minHeight: isMobile ? 70 : "auto" }}
      >
        <div className="container py-2">
          {/* ===== HAMBURGUESA MÓVIL ===== */}
          {isMobile && (
            <div className="mb-2">
              <button
                onClick={() => offcanvasInstance.current?.show()}
                style={{
                  backgroundColor: "#003366",
                  border: "none",
                  borderRadius: "60px",
                  padding: "10px 14px",
                  color: "#fff",
                }}
              >
                <span className="navbar-toggler-icon"></span>
              </button>
            </div>
          )}

          {/* ===== BOTONES MÓVIL ===== */}
          {isMobile && (
            <div className="d-flex justify-content-center gap-2">
              {botones.map((b, i) =>
                b.type === "link" ? (
                  <Link key={i} to={b.to} className={b.className}>
                    <i className={`fa-solid ${b.icon}`}></i> {b.text}
                  </Link>
                ) : (
                  <button key={i} className={b.className}>
                    <i className={`fa-solid ${b.icon}`}></i> {b.text}
                  </button>
                )
              )}
            </div>
          )}

          {/* ===== DESKTOP ===== */}
          {!isMobile && (
            <div className="position-relative d-flex justify-content-center align-items-center">
              <button
                onClick={() => offcanvasInstance.current?.show()}
                style={{
                  position: "absolute",
                  left: 10,
                  backgroundColor: "#003366",
                  border: "none",
                  borderRadius: "60px",
                  padding: "8px 16px",
                  color: "#fff",
                }}
              >
                <span className="navbar-toggler-icon"></span>{" "}
                <span>Todas las categorías</span>
              </button>

              <div className="d-flex gap-3">
                {botones.map((b, i) =>
                  b.type === "link" ? (
                    <Link key={i} to={b.to} className={b.className}>
                      <i className={`fa-solid ${b.icon}`}></i> {b.text}
                    </Link>
                  ) : (
                    <button
                      key={i}
                      className={b.className}
                      data-bs-toggle="modal"
                      data-bs-target="#contactModal"
                    >
                      <i className={`fa-solid ${b.icon}`}></i> {b.text}
                    </button>
                  )
                )}
              </div>
            </div>
          )}
        </div>
      </div>

      {/* ===== OFFCANVAS ===== */}
      <div ref={offcanvasRef} className="offcanvas offcanvas-start">
        <div
          className="offcanvas-header"
          style={{
            backgroundColor: "#00377b",
            color: "white",
            borderRadius: "40px",
            padding: "0.5rem 1rem", // 🔹 menos relleno arriba/abajo y a los lados
            margin: "10px 10px 10px 10px",
          }}
        >
          <h5 style={{ margin: 0 }}>Categorías</h5> {/* 🔹 elimina margen extra */}
          <button className="btn-close btn-close-white" data-bs-dismiss="offcanvas"></button>
        </div>


        <div className="offcanvas-body p-0">
          <ul className="list-group list-group-flush">
            {categories.filter((c) => c.nombre.toLowerCase() !== "liquidacion").map((c) => (
              <li key={c.id} style={{ background: "white" }}>
                <button
                  className="w-100 text-start btn"
                  style={{
                    background: "white",
                    color: "#333",
                    border: "none",
                    borderRadius: 0,
                    boxShadow: "none",
                  }}
                  onClick={() =>
                    handleCategoryClick(`/productos/${c.nombre.replaceAll(" ", "-")}`)
                  }
                >
                  {c.nombre}
                </button>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
